import Amplify from 'aws-amplify';
import dayjs from 'dayjs';
import advancedFormatPlugin from 'dayjs/plugin/advancedFormat';
import calendarPlugin from 'dayjs/plugin/calendar';
import durationPlugin from 'dayjs/plugin/duration';
import timezonePlugin from 'dayjs/plugin/timezone';
import utcPlugin from 'dayjs/plugin/utc';
import { elementScrollIntoViewPolyfill } from 'seamless-scroll-polyfill';

import config from 'config';

import { AppStorage } from 'types';
import { revalidateAppCache } from 'utils';
import { i18n, LoggerService, RTCService, RTMService, storage, tracker } from 'services';

dayjs.extend(calendarPlugin);
dayjs.extend(timezonePlugin);
dayjs.extend(advancedFormatPlugin);
dayjs.extend(utcPlugin);
dayjs.extend(durationPlugin);

/**
 * Sample: https://docs.amplify.aws/lib/auth/start/q/platform/js#re-use-existing-authentication-resource
 */
Amplify.configure({ Auth: config.aws.auth });

i18n.init({
  languages: config.language.list,
  initialLanguage: storage.local.get(config.language.key) || config.language.initial,
  onChange: language => storage.local.set(config.language.key, language)
});

RTCService.init();
RTMService.init();
LoggerService.init({
  dsn: config.sentry.dsn,
  environment: config.app.env,
  release: config.app.env === 'production' ? config.app.version : config.app.commit
});

tracker.init({
  debug: config.app.env !== 'production'
});

// Issue: element.scrollIntoView is not supported in safari browser: https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView#browser_compatibility
// Source: https://stackoverflow.com/questions/65552682/scrollintoview-is-not-working-as-expected-in-safari-browser#comment115897962_65552853
elementScrollIntoViewPolyfill();

if (!['local', 'development'].includes(config.app.env)) {
  console.log = () => {};
}

if (['local', 'development'].includes(config.app.env)) {
  (async () => {
    const reportWebVitals = await import('./reportWebVitals');

    reportWebVitals.default(console.log);
  })();
}

if (storage.local.get(AppStorage.Local.VERSION) !== config.app.version) {
  revalidateAppCache();
}
